import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Card #4387: drag-to-reorder for the All Cards hub's "Ready to Release"
// quick filter. Modelled on result_card_sortable_controller.js -- this
// controller's own element IS the sortable list, no separate target needed.
//
// The one real difference from every other card-sortable usage: this list
// can span multiple projects (the All Cards hub has no single @project), so
// there's no single reorder endpoint to call. Rather than invent a new
// cross-project endpoint, this reuses the SAME per-project endpoint the
// Kanban board already persists position through (CardsController#reorder),
// calling it once per project present in the dropped order. Each project's
// own cards are renumbered 0..n-1 within that project only -- ties between
// different projects' cards then break by id (see
// ProjectHub::AllCardsController#setup_filters). That's the accepted
// trade-off for reusing the existing endpoint unmodified rather than adding
// a new global "ship order" column.
export default class extends Controller {
  connect() {
    this._sortable = Sortable.create(this.element, {
      handle:         "[data-sort-handle]",
      draggable:      "turbo-frame",
      animation:      150,
      ghostClass:     "opacity-40",
      chosenClass:    "shadow-lg",
      forceFallback:  true,
      fallbackOnBody: false,
      swapThreshold:  0.65,
      onEnd: () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  _persistOrder() {
    const cardEls = Array.from(this.element.querySelectorAll("[data-card-id]"))
    if (cardEls.length === 0) return

    // Preserve each project's own relative order as it appears in the
    // dropped list, grouped by project so each group can go to its own
    // project-scoped reorder endpoint.
    const idsByProject = new Map()
    cardEls.forEach(el => {
      const projectId = el.dataset.projectId
      const cardId = el.dataset.cardId
      if (!projectId || !cardId) return
      if (!idsByProject.has(projectId)) idsByProject.set(projectId, [])
      idsByProject.get(projectId).push(cardId)
    })

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    idsByProject.forEach((cardIds, projectId) => {
      fetch(`/projects/${projectId}/cards/reorder`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ card_ids: cardIds })
      })
    })
  }
}
